import React from 'react';
import { wrapDisplayName } from 'recompose';
import { ErrorBoundary } from '../components/ErrorBoundary';

export const withErrorBoundary = WrappedComponent => {
  const WrappedComponentWithErrorBoundary = props => (
    <ErrorBoundary>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  wrapDisplayName(WrappedComponentWithErrorBoundary, 'withErrorBoundary');

  return WrappedComponentWithErrorBoundary;
};



// WEBPACK FOOTER //
// ./src/hocs/withErrorBoundary.jsx